import React from 'react';
import './index.scss';
import loaderGif from '../../assets/img/emil_loader.gif';

const PetLoader = ({ show }) => {
  // // debug-console.log('PetLoader: ' + show);
  if (!show) return null;
  return (
    <div className="loader-wrapper">
      <div className="loader-gif-outerContainer">
        <div className="loader-gif-innerContainer">
          <img src={loaderGif} alt="loading" />
        </div>
      </div>
    </div>
  );
};

export default PetLoader;
